import { useOktaAuth } from '@okta/okta-react';
import { Dashboard } from '@optools/app/components/dashboard/dashboard';
import { PageLoader } from '@optools/components/loading/page-loader';
import { Toaster } from '@optools/components/ui/sonner';
import { EnvironmentConfig } from '@optools/services/config/types';
import { OktaProfile } from '@optools/store/oktaApiSlice';
import { createRootRouteWithContext, Outlet, useLocation } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

export interface RouterContext {
  auth: ReturnType<typeof useOktaAuth>;
  config: EnvironmentConfig;
  profile: OktaProfile;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFoundComponent,
  pendingComponent: () => <PageLoader withDelay />,
});

export function RootComponent() {
  return (
    <>
      <Toaster richColors />
      <Dashboard>
        <Outlet />
        <TanStackRouterDevtools position="top-right" />
      </Dashboard>
    </>
  );
}

function NotFoundComponent() {
  const location = useLocation();
  return <h1 className="p-4 text-2xl font-normal">{`${location.pathname} is not a valid url.`}</h1>;
}
